import React from 'react'
import './Footer.scss'

const Footer = () => (
  <div className='footer'>
    <p>Created by SelcukToklucu 2019</p>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/footer/Footer.js